import { IContactFormData } from 'src/SharedCustomHooks/UseContactFormData/types';
import {
  useContactAPIOperationsContacts
} from 'src/pages/SharedPageCustomHooks/UseContactSaveContactsPage/useContactAPIOperationsContactsPage';

interface UseContactFormSubmissionContactsOptions {
  onSuccess?: () => void;
  onClose?: any;
}

interface UseContactFormSubmissionContactsReturn {
  handleSubmitContactForm: (
    formData: IContactFormData
  ) => Promise<void>;
  isLoading: boolean;
}

export const useContactFormSubmissionContacts = ({
  onSuccess,
  onClose,
}: UseContactFormSubmissionContactsOptions): UseContactFormSubmissionContactsReturn => {
  const { onCreateContact, onEditContact, isLoading } =
    useContactAPIOperationsContacts();
  
  const handleSubmitContactForm = async (
    formData: IContactFormData
  ): Promise<void> => {
    try {
      let submissionSuccess: boolean;
      
      // Contacts page logic: Simple create or edit.
      if (formData.id) {
        // Editing existing contact.
        submissionSuccess = await onEditContact(formData);
      } else {
        // Creating new contact.
        submissionSuccess = await onCreateContact(formData);
      }
      
      if (submissionSuccess) {
        onSuccess?.();
      }
      
      onClose?.();
    } catch (error) {
      console.error('Contact form submission failed:', error);
    }
  };
  
  return {
    handleSubmitContactForm,
    isLoading,
  };
};